import { Form } from '@unform/web';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormWrapper = styled(Form)`
  width: 100%;

  flex: 1;
  display: flex;
  flex-direction: column;

  > div:not(:last-child) {
    margin-bottom: 0.5rem;
  }

  p.Mui-error {
    margin: 0rem;
  }
`;

export const GroupButtons = styled.div`
  margin-top: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  > button {
    margin-left: 0.5rem;
  }
`;
